import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row } from 'reactstrap';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import TableService from '../../../../Services/QRCodeServices/TableSerivce/TableService';
import { Triangle } from 'react-loader-spinner';

export const BarOrderToken = () => {
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTables = async () => {
      try {
        const response = await TableService.getActiveTableList();
        setTables(response);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching tables:', error);
        setError(error);
        setLoading(false);
      }
    };

    fetchTables();
  }, []);

  const filteredOrders = tables
    .map(table => ({
      ...table,
      menuOrder: {
        ...table.menuOrder,
        menuOrderDetails: table.menuOrder?.menuOrderDetails?.filter(item => item.menuItemDetail?.isBOT) || [],
      },
    }))
    .filter(table => table.menuOrder.menuOrderDetails.length > 0); 

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Triangle
          visible={true}
          height="80"
          width="80"
          color="#5B71B9"
          ariaLabel="triangle-loading"
        />
      </div>
    );
  }

  if (error) {
    return <div>Error fetching data. Please try again later.</div>;
  }

  return (
    <div className="w-100 d-flex justify-content-center align-items-center">
      <Row className="container-fluid mt-4">
        {filteredOrders.map((order, index) => (
          <Col lg={3} md={4} sm={6} key={index}>
            <Card className="shadow-sm hover-shadow-lg transition-all">
              <CardBody className="p-3">
                {/* Order Header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0 text-primary fw-bold">{order.identification}</h5>
                  <span className="badge bg-success">{order.menuOrder?.orderType || 'N/A'}</span>
                </div>

                {/* Order Items */}
                <SimpleBar style={{ maxHeight: '200px' }} className="p-0">
                  <ul className="list-unstyled mb-0">
                    {order.menuOrder?.menuOrderDetails?.map((item, itemIndex) => (
                      <li key={itemIndex} className="mb-2">
                        <Link to="#" className="text-decoration-none">
                          <div className="d-flex align-items-center p-2 bg-light rounded">
                            {/* Item Image */}
                            <div className="flex-shrink-0 me-3">
                              <img
                                src={item?.menuItemDetail?.cloudR2ImagePath?.getCDNUrl()}
                                alt={item.menuItemDetail?.title || 'Item'}
                                className="img-fluid rounded"
                                style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                              />
                            </div>

                            {/* Item Details */}
                            <div className="flex-grow-1">
                              <h6 className="mb-0 text-dark fw-semibold">
                                {item.menuItemDetail?.title || 'Unnamed Item'}
                              </h6>
                              <small className="text-muted">Quantity: {item.quantity}</small>
                            </div>
                          </div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </SimpleBar>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};